import { WALLET_TRANSACTION_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  walletTransactionReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const walletTransactionReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case WALLET_TRANSACTION_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case WALLET_TRANSACTION_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        walletTransactionReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case WALLET_TRANSACTION_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default walletTransactionReportReducer;
